import React from 'react';

import { useCard } from '@src/reducers/product';

import styles from '../../styles.module.scss';

export const Prolongation = () => {
    const card = useCard();

    const hasProlongation = card?.prolongation.isAllowed && Boolean(card?.prolongation.information);
    const prolongationInformation = hasProlongation
        ? card.prolongation.information
        : 'В данном МФО отсутствует возможность продления займа';

    return (
        <div className={styles.cardItem}>
            <div className={styles.title}>{hasProlongation ? 'Да' : 'Нет'}</div>
            <div className={styles.text}>{prolongationInformation}</div>
        </div>
    );
};
